import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import {environment} from 'src/environments/environment'
import { User } from '../models/user';
import { Globals } from './global';
import { AgoraConfigService } from 'src/AgoraConfigService';


@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;
    emptyUser : any;
    headers: HttpHeaders;
    isAuthenticated: boolean = false;
    private userLoggedIn = new Subject<boolean>();
    agoraConfigObject: any;

   constructor(private http: HttpClient,private globals:Globals, private agoraConfig: AgoraConfigService) {
    this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;
        this.headers = new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8')
        .set("Access-Control-Allow-Origin", "*")
        .set("Access-Control-Allow-Headers", "*")
        .set("Access-Control-Allow-Methods", "GET,POST,PUT,DELETE");
        
        this.emptyUser = localStorage.getItem('currentUser');
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(this.emptyUser));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }
    public get getAuthStatus():boolean{
        return this.isAuthenticated;
    }

    loginUser(username: string, password: string,loginKey:string) {
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}/login-service/login/validateUser`, { userName: username, password: password,loginKey:loginKey },{headers:this.headers})
            .pipe(map(user => {
                // login successful if there's a jwt token in the response
                if (user) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                    this.isAuthenticated = true;
                    this.currentUserSubject.next(user);
                    this.userLoggedIn.next(this.isAuthenticated);
                }
                return user;
            }));
    }

    logout() {
        this.userLoggedIn.next(false);
        var reqJSON = {"userName":localStorage.getItem("userName")};
        localStorage.removeItem("userId");
        localStorage.removeItem("userName");
        localStorage.removeItem("currentUser");
        localStorage.clear();
        this.currentUserSubject.next(new User());
        this.unBoundSession(reqJSON).subscribe(res => {});
        this.globals.resetGlobals();
    }
    unBoundSession(reqJSON:any){
        return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}/login-service/login/unBoundSession`, reqJSON,{headers:this.headers,observe: 'response'});
    }
    public getUserLoggedIn(): Observable<boolean> {
        return this.userLoggedIn.asObservable();}
        
        public getloggedUserValue(): Observable<User> {
            return this.currentUserSubject.asObservable();
        }    

    }
